<span class="dataspace-status-badge" [class]="badgeClass">
  {{ status }}
</span>
